import React, { useState } from 'react';
import {
  TextField,
  Typography,
  Checkbox,
  Button,
  Box,
  Paper,
} from '@mui/material'; // Removed unused imports
import { postWithTokenAPI } from '../../utils/Api';
import { useNavigate } from "react-router-dom"; // Removed unused imports
import { toast } from "react-toastify";


const Createrole = () => {
  const navigate = useNavigate();
  const [roleData, setRolesData] = useState({
    role_name: "",
    permissions: []
  });

  const [modules, setModules] = useState([
    {
      name: 'User',
      permissions: {
        view: false,
        create: null,
        update: null,
        delete: null,
      }
    },
    {
      name: 'Seller',
      permissions: {
        view: false,
        create: false,
        update: false,
        delete: null,
      }
    },
    {
      name: 'Category',
      permissions: {
        view: false,
        create: false,
        update: false,
        delete: null,
      }
    },
    {
      name: 'Product',
      permissions: {
        view: false,
        create: false,
        update: false,
        delete: null,
      }
    },
    {
      name: 'Order',
      permissions: {
        view: false,
        create: null,
        update: null,
        delete: null,
      }
    },
    {
      name: 'Blog',
      permissions: {
        view: false,
        create: false,
        update: false,
        delete: false,
      }
    },
    {
      name: 'Drone',
      permissions: {
        view: false,
        create: null,
        update: false,
        delete: null,
      }
    },
    {
      name: 'Soiltest',
      permissions: {
        view: false,
        create: null,
        update: false,
        delete: null,
      }
    },
    {
      name: 'Farmdata',
      permissions: {
        view: false,
        create: null,
        update: null,
        delete: null,
      }
    },
    {
      name: 'Role',
      permissions: {
        view: false,
        create: false,
        update: false,
        delete: false,
      }
    },
    {
      name: 'Resource',
      permissions: {
        view: false,
        create: false,
        update: null,
        delete: false,
      }
    },
    {
      name: 'Newsletter',
      permissions: {
        view: false,
        create: null,
        update: null,
        delete: null,
      }
    },
    {
      name: 'Enquiries',
      permissions: {
        view: false,
        create: null,
        update: null,
        delete: null,
      }
    },
    {
      name: 'Wishlist',
      permissions: {
        view: false,
        create: null,
        update: null,
        delete: null,
      }
    },
    {
      name: 'Cart',
      permissions: {
        view: false,
        create: null,
        update: null,
        delete: null,
      }
    },
    {
      name: 'Revenue',
      permissions: {
        view: false,
        create: null,
        update: null,
        delete: null,
      }
    },
     {
      name: 'subscription',
      permissions: {
        view: false,
        create: null,
        update: null,
        delete: null,
      }
    },
     {
      name: 'Dronemanagement',
      permissions: {
        view: false,
        create: false,
        update: null,
        delete: false,
      }
    },
 
  ]);

  const handlePermissionChange = (moduleIndex, permission) => {
    const updatedModules = [...modules];
    updatedModules[moduleIndex].permissions[permission] =
      !updatedModules[moduleIndex].permissions[permission];
    setModules(updatedModules);
  };

  const handleSelectAll = (moduleIndex) => {
    const updatedModules = [...modules];
    const currentModule = updatedModules[moduleIndex];

    // Get only the permissions that are not null
    const controllablePermissions = Object.keys(currentModule.permissions).filter(
      (perm) => currentModule.permissions[perm] !== null
    );

    // Check if all controllable permissions are currently selected
    const allSelected = controllablePermissions.every(
      (perm) => currentModule.permissions[perm] === true
    );

    // Toggle only the controllable permissions
    controllablePermissions.forEach((perm) => {
      currentModule.permissions[perm] = !allSelected;
    });

    setModules(updatedModules);
  };

  const handleSubmit = async () => {
    const permissions = modules.flatMap(module => {
      const moduleKey = module.name.toLowerCase().replace(/\s+/g, '_');
      return Object.entries(module.permissions)
        .filter(([_, isEnabled]) => isEnabled)
        .map(([permission]) => `${permission}_${moduleKey}`);
    });

    const payload = {
      ...roleData,
      permissions: permissions
    };
    const token = localStorage.getItem("token");
    try {
      const response = await postWithTokenAPI(token, "/rolemanagement/create", payload);
      if (response.statusCode === 200) {
        toast.success("Role status Create successfully!")
        navigate("/backoffice/rolemanagement");
      } else {
        toast.error("Failed to Create Role : " + response.message);
      }
    } catch (error) {
      toast.error("An error occurred while creating Admin: " + error.message); // Better error message
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 3, maxWidth: 1200 }}>
      <Typography variant="h5" gutterBottom>
        Create New Role
      </Typography>

      <Box >
        <TextField
          value={roleData.role_name}
          label="Role Name"
          fullWidth
          onChange={(e) => {
            setRolesData(prev => ({
              ...prev,
              role_name: e.target.value
            }));
          }}
        />
      </Box>


      <Typography variant="h6" sx={{ mt: 3, mb: 2 }}>
        Module Access
      </Typography>

      <Box sx={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ textTransform: "capitalize", backgroundColor: '#f5f5f5' }}>
              <th style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #ddd' }}>Module</th>
              {modules[0]?.permissions && Object.keys(modules[0].permissions).map(perm => (
                <th key={perm} style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #ddd' }}>
                  {perm}
                </th>
              ))}
              <th style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #ddd' }}>Select All</th>
            </tr>
          </thead>
          <tbody>
            {modules.map((module, moduleIndex) => (
              <tr key={moduleIndex} style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '12px', fontWeight: '500' }}>{module.name}</td>
                {Object.keys(module.permissions).map((permission) => (
                  <td key={permission} style={{ padding: '12px', textAlign: 'center' }}>
                    <Checkbox
                      checked={module.permissions[permission] === true} // Explicitly check for true
                      disabled={module.permissions[permission] === null}
                      onChange={() => handlePermissionChange(moduleIndex, permission)}
                      color="primary"
                    />
                  </td>
                ))}
                <td style={{ padding: '12px', textAlign: 'center' }}>
                  <Checkbox
                    checked={
                      Object.values(module.permissions).filter(p => p !== null).every(Boolean) &&
                      Object.values(module.permissions).filter(p => p !== null).length > 0 // Ensure there's at least one non-null permission
                    }
                    onChange={() => handleSelectAll(moduleIndex)}
                    style={{ color: "green" }}
                    indeterminate={
                      Object.values(module.permissions).some(p => p === true) &&
                      Object.values(module.permissions).some(p => p === false)
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={!roleData.role_name.trim()}
        >
          Create Role
        </Button>
      </Box>
    </Paper>
  );
};

export default Createrole;